import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { classNames, useContext } from 'libs/react';
import { React } from 'libs/react';
import { TableContext } from 'components/table/Table';
import './TableLabel.scss';
/**
 * @interface TableLabel
 * @since 1.0.0
 */
export function TableLabel(props) {
    const { style, title, infos, field } = Object.assign({ style: 'normal' }, props);
    const { onSort, sortable, setSortField, setSortOrder, sortField, sortOrder } = useContext(TableContext);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        const newSortField = field;
        let newSortOrder;
        if (sortField == field) {
            newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        }
        else {
            newSortOrder = 'asc';
        }
        setSortField(newSortField);
        setSortOrder(newSortOrder);
        onSort(newSortField, newSortOrder);
    }
    if (sortable && sortable.includes(field)) {
        let picto = 'fas sort-up';
        if (sortField == field) {
            switch (sortOrder) {
                case 'asc':
                    picto = 'fas sort-down';
                    break;
                case 'desc':
                    picto = 'fas sort-up';
                    break;
            }
        }
        const className = classNames('table-label-sort-picto', {
            'table-label-sort-picto--active': sortField == field
        });
        return (React.createElement("span", { className: "table-label table-label--sortable", onClick: onClick },
            React.createElement("span", { className: "table-label-text" }, title),
            React.createElement("span", { className: "table-label-infos" }, infos),
            React.createElement("span", { className: "table-label-sort" },
                React.createElement(Icon, { className: className, value: picto }))));
    }
    return (React.createElement("span", { className: "table-label" },
        React.createElement("span", { className: "table-label-text" }, title),
        infos && (React.createElement("div", { className: "table-label-tooltip" },
            React.createElement(Icon, { className: "table-label-tooltip-picto", value: "circle-info" }),
            React.createElement(Text, { className: "table-label-tooltip-value", value: infos })))));
}
